import React, {Fragment} from 'react';
import Iframe from 'react-iframe'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Fade, Container, Button, Modal} from 'react-bootstrap';
import {Helmet} from 'react-helmet';
import Cookies from 'universal-cookie';
import {getSharedVideo, hideLoginModal} from '../actions/player';
import Configuration from '../config';
import ReplayerCommunitySportivi from '../images/Replayer_community_sportivi.jpg';
import {useTranslation, Trans} from 'react-i18next';
import {push} from 'connected-react-router';

let firstAccess = true;
let isAuthorized = false;
const cookies = new Cookies();
const auth = cookies.get('replayerAuth');

const VideoSharing = ({match: {params: {sharedId}}, getSharedVideo, sharedVideo, token, isLoginModalVisible, hideLoginModal, goto}) => {

  const {t} = useTranslation();
  const [selectedFolderVideoId, setSelectedFolderVideoId] = React.useState(null);
  const [selectedPlaylistVideoIndex, setSelectedPlaylistVideoIndex] = React.useState(null);
  const [showFolderIntro, setShowFolderIntro] = React.useState(false);
  const [playlistIntroSelection, setPlaylistIntroSelection] = React.useState(null);
  const autoAdvanceLockRef = React.useRef(false);
  const playRetryTimeoutRef = React.useRef(null);
  if (firstAccess && !auth) {
    getSharedVideo(sharedId);
    firstAccess = false;
  }

  if (token && !isAuthorized) {
    getSharedVideo(sharedId);
    isAuthorized = true;
  }

  const isFolderSharing = sharedVideo && sharedVideo.type === 'highlight_folder';
  const folderVideos = isFolderSharing ? sharedVideo.videos || [] : [];
  const hasMultipleFolderVideos = folderVideos.length > 1;
  const playlistVideos = !isFolderSharing && sharedVideo ? (
    sharedVideo.videos ||
    sharedVideo.highlights ||
    sharedVideo.items ||
    sharedVideo.highlightItems ||
    sharedVideo.playlistItems ||
    []
  ) : [];
  const isPlaylistSharing = !isFolderSharing && sharedVideo && (
    sharedVideo.type === 'playlist' ||
    sharedVideo.type === 'highlight_playlist' ||
    sharedVideo.playlistId ||
    sharedVideo.playlistVideoId ||
    playlistVideos.length > 0
  );
  const hasMultiplePlaylistVideos = isPlaylistSharing && playlistVideos.length > 1;
  const selectedFolderVideoIndex = isFolderSharing
    ? Math.max(0, folderVideos.findIndex(video => video.videoId === selectedFolderVideoId))
    : -1;
  const selectedFolderVideo = isFolderSharing ?
    folderVideos.find(video => video.videoId === selectedFolderVideoId) || folderVideos[0] :
    null;
  const selectedPlaylistVideo = isPlaylistSharing && playlistVideos.length > 0
    ? playlistVideos[selectedPlaylistVideoIndex === null ? 0 : selectedPlaylistVideoIndex] || playlistVideos[0]
    : null;
  const playerUrl = video => {
    if (!video) {
      return '';
    }
    if (video.playerUrl || video.url) {
      return video.playerUrl || video.url;
    }
    if (video.videoId && video.slotId && video.token) {
      return `${Configuration.krpanoPlayerUrl}?slotId=${video.slotId}&videoId=${video.videoId}&token=${video.token}`;
    }
    if (video.id && video.slotId && video.token) {
      return `${Configuration.krpanoPlayerUrl}?slotId=${video.slotId}&playlistId=${video.id}&token=${video.token}`;
    }
    if (video.slotId && video.token) {
      return `${Configuration.krpanoPlayerUrl}?slotId=${video.slotId}&token=${video.token}`;
    }
    return '';
  };
  const selectedPlaylistPlayerUrl = playerUrl(selectedPlaylistVideo);
  const selectedPlayerUrl = isFolderSharing
    ? playerUrl(selectedFolderVideo)
    : isPlaylistSharing && selectedPlaylistPlayerUrl
      ? selectedPlaylistPlayerUrl
      : playerUrl(sharedVideo);
  const videoTitle = video => video && (video.name || video.title || video.videoName || video.highlightName || 'Highlight');
  const videoDescription = video => video && (video.description || video.fieldName || video.partnerName || '');
  const playlistIntroVideo = playlistIntroSelection && playlistVideos[playlistIntroSelection.index]
    ? playlistVideos[playlistIntroSelection.index]
    : null;
  const introVideo = isFolderSharing ? selectedFolderVideo : playlistIntroVideo;
  const introVideoIndex = isFolderSharing
    ? selectedFolderVideoIndex
    : playlistIntroSelection ? playlistIntroSelection.index : -1;
  const introVideoCount = isFolderSharing ? folderVideos.length : playlistVideos.length;
  const showSharedIntro = Boolean(
    introVideo
    && (
      (isFolderSharing && showFolderIntro)
      || (isPlaylistSharing && playlistIntroSelection)
    )
  );
  const videoDurationSeconds = video => {
    if (!video) {
      return 0;
    }

    const directDuration = Number(
      video.durationSeconds
      || video.duration_seconds
      || video.duration
      || video.videoDurationSeconds
      || 0
    );
    if (directDuration > 0) {
      return directDuration;
    }

    const durationFromParts = (Number(video.duration_minutes || 0) * 60) + Number(video.duration_seconds || 0);
    if (durationFromParts > 0) {
      return durationFromParts;
    }

    const start = Number(video.startSeconds || video.start_second || video.start || 0);
    const end = Number(video.endSeconds || video.end_second || video.end || 0);
    return end > start ? end - start : 0;
  };
  const selectPlaylistVideo = (video, index) => {
    setSelectedPlaylistVideoIndex(index);
    setPlaylistIntroSelection({index});
  };

  const selectFolderVideo = video => {
    autoAdvanceLockRef.current = false;
    setSelectedFolderVideoId(video.videoId);
  };

  const tryPlaySharedIframeVideo = React.useCallback(() => {
    const iframeRef = document.getElementById("sharedVideoIframe");
    if (!iframeRef || !iframeRef.contentWindow) {
      return false;
    }

    try {
      const krpano = iframeRef.contentWindow.krpano;
      if (krpano) {
        try {
          krpano.call("plugin[video].play()");
          return true;
        } catch (error) {
          krpano.set("plugin[video].paused", false);
          return true;
        }
      }
    } catch (error) {
      // Browser autoplay or cross-frame restrictions can prevent direct control.
    }

    try {
      const videoElement = iframeRef.contentWindow.document.querySelector("video");
      if (videoElement && videoElement.paused) {
        const playResult = videoElement.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(() => {});
        }
        return true;
      }
    } catch (error) {
      // Keep the existing manual play fallback if the iframe cannot be controlled.
    }

    return false;
  }, []);

  const playSharedIframeVideo = React.useCallback(() => {
    let attempt = 0;
    const runAttempt = () => {
      if (tryPlaySharedIframeVideo() || attempt >= 5) {
        return;
      }

      attempt += 1;
      playRetryTimeoutRef.current = window.setTimeout(() => {
        runAttempt();
      }, 350);
    };

    runAttempt();
  }, [tryPlaySharedIframeVideo]);

  React.useEffect(() => {
    autoAdvanceLockRef.current = false;
  }, [selectedPlayerUrl]);

  React.useEffect(() => {
    if (!isFolderSharing || !selectedFolderVideo) {
      setShowFolderIntro(false);
      return undefined;
    }

    setShowFolderIntro(true);
    if (playRetryTimeoutRef.current) {
      window.clearTimeout(playRetryTimeoutRef.current);
    }

    const introTimeout = window.setTimeout(() => {
      setShowFolderIntro(false);
      playSharedIframeVideo();
    }, 4000);

    return () => {
      window.clearTimeout(introTimeout);
      if (playRetryTimeoutRef.current) {
        window.clearTimeout(playRetryTimeoutRef.current);
      }
    };
  }, [isFolderSharing, playSharedIframeVideo, selectedFolderVideo, selectedPlayerUrl]);

  React.useEffect(() => {
    if (!isPlaylistSharing || playlistVideos.length === 0 || selectedPlaylistVideoIndex !== null || playlistIntroSelection) {
      return;
    }

    setSelectedPlaylistVideoIndex(0);
    setPlaylistIntroSelection({index: 0});
  }, [isPlaylistSharing, playlistIntroSelection, playlistVideos.length, selectedPlaylistVideoIndex]);

  React.useEffect(() => {
    if (!isPlaylistSharing || !playlistIntroSelection) {
      return undefined;
    }

    if (playRetryTimeoutRef.current) {
      window.clearTimeout(playRetryTimeoutRef.current);
    }

    const introTimeout = window.setTimeout(() => {
      const selectedVideo = playlistVideos[playlistIntroSelection.index];
      setPlaylistIntroSelection(null);
      if (selectedVideo) {
        setSelectedPlaylistVideoIndex(playlistIntroSelection.index);
        playSharedIframeVideo();
      }
    }, 4000);

    return () => {
      window.clearTimeout(introTimeout);
      if (playRetryTimeoutRef.current) {
        window.clearTimeout(playRetryTimeoutRef.current);
      }
    };
  }, [isPlaylistSharing, playSharedIframeVideo, playlistIntroSelection, playlistVideos]);

  React.useEffect(() => {
    if (!isPlaylistSharing || playlistVideos.length <= 1 || playlistIntroSelection || !selectedPlaylistVideo) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      const iframeRef = document.getElementById("sharedVideoIframe");
      if (!iframeRef || !iframeRef.contentWindow) {
        return;
      }

      let currentSeconds = 0;
      let durationSeconds = videoDurationSeconds(selectedPlaylistVideo);
      try {
        const krpano = iframeRef.contentWindow.krpano;
        if (!krpano) {
          return;
        }
        currentSeconds = Number(krpano.get("plugin[video].time") || 0);
        durationSeconds = Number(
          krpano.get("plugin[video].duration")
          || krpano.get("plugin[video].totaltime")
          || krpano.get("plugin[video].totalTime")
          || durationSeconds
        );
      } catch (error) {
        return;
      }

      if (!durationSeconds || currentSeconds < Math.max(0, durationSeconds - 0.75)) {
        return;
      }

      const nextIndex = (selectedPlaylistVideoIndex === null ? 0 : selectedPlaylistVideoIndex) + 1;
      if (nextIndex >= playlistVideos.length) {
        return;
      }

      setSelectedPlaylistVideoIndex(nextIndex);
      setPlaylistIntroSelection({index: nextIndex});
    }, 500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isPlaylistSharing, playlistIntroSelection, playlistVideos, selectedPlaylistVideo, selectedPlaylistVideoIndex]);

  React.useEffect(() => {
    if (!isFolderSharing || folderVideos.length <= 1 || !selectedFolderVideo) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      const iframeRef = document.getElementById("sharedVideoIframe");
      if (!iframeRef || !iframeRef.contentWindow || autoAdvanceLockRef.current) {
        return;
      }

      let currentSeconds = 0;
      let durationSeconds = videoDurationSeconds(selectedFolderVideo);
      try {
        const krpano = iframeRef.contentWindow.krpano;
        if (!krpano) {
          return;
        }
        currentSeconds = Number(krpano.get("plugin[video].time") || 0);
        durationSeconds = Number(
          krpano.get("plugin[video].duration")
          || krpano.get("plugin[video].totaltime")
          || krpano.get("plugin[video].totalTime")
          || durationSeconds
        );
      } catch (error) {
        return;
      }

      if (!durationSeconds || currentSeconds < Math.max(0, durationSeconds - 0.75)) {
        return;
      }

      const nextIndex = selectedFolderVideoIndex + 1;
      if (nextIndex >= folderVideos.length) {
        autoAdvanceLockRef.current = true;
        return;
      }

      autoAdvanceLockRef.current = true;
      setSelectedFolderVideoId(folderVideos[nextIndex].videoId);
    }, 750);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [folderVideos, isFolderSharing, selectedFolderVideo, selectedFolderVideoIndex]);

  return (
    <Fragment>
      <Helmet>
        <title>{`${isFolderSharing ? 'Cartella Highlight Replayer' : 'Video Replayer'}: ${sharedVideo ? sharedVideo.name : ''}`}</title>
        <meta name="description" content={`Guarda il video! ${sharedVideo ? sharedVideo.description : ''}`}/>
        <meta property="og:site_name" content="Replayer"/>
        <meta property="og:title" content={`Video Replayer: ${sharedVideo ? sharedVideo.name : ''}`}/>
        <meta property="og:description" content={`Guarda il video! ${sharedVideo ? sharedVideo.description : ''}`}/>
        <meta property="og:image" content={`${Configuration.baseUrl}${ReplayerCommunitySportivi}`}/>
        <meta property="og:image:width" content="1200"/>
        <meta property="og:image:height" content="630"/>
        <meta property="og:url" content={`${Configuration.sharedVideoBaseUrl}/${sharedId}`}/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta property="og:type" content="video.other"/>
        <meta property="og:video:url" content={`${Configuration.sharedVideoBaseUrl}/${sharedId}`}/>
        <meta property="og:video:secure_url" content={`${Configuration.sharedVideoBaseUrl}/${sharedId}`}/>
        <meta property="og:video:type" content="text/html"/>
        <meta property="og:video:width" content="1280"/>
        <meta property="og:video:height" content="720"/>
      </Helmet>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear'}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section" style={{paddingBottom: 200}}>
              <div className="container">
                <div className="row" style={{marginTop: 100}}>
                  <div className="col-md-12 ml-auto mr-auto">
                    <h3 className="text-center section_title_neg_rp">
                      {(isFolderSharing && hasMultipleFolderVideos) || hasMultiplePlaylistVideos
                        ? 'Benvenuto nella community degli sportivi, questi video sono per te'
                        : t('WELCOME_VIDEO_SHARING')}
                    </h3>
                  </div>
                </div>
                <div className="row" style={{marginTop: 100}}>
                  <div className="col-md-12 col-lg-12 mb-sm-12 card-group">
                    <div className="card video_card_bg_rp">
                      <div className="card_image_rp">
                        <div className="videoWrapper" style={{position: 'relative'}}>
                          <Iframe id="sharedVideoIframe" key={selectedPlayerUrl} url={selectedPlayerUrl} allowFullScreen/>
                          {showSharedIntro && (
                            <div
                              className="shared-folder-video-intro"
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                                zIndex: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 24,
                                color: '#ffffff',
                                textAlign: 'center',
                                pointerEvents: 'none',
                                background: 'rgba(8, 22, 37, 0.78)'
                              }}
                            >
                              <div style={{fontSize: 13, fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', opacity: 0.8}}>
                                Highlight {introVideoIndex + 1} di {introVideoCount}
                              </div>
                              <strong style={{fontSize: 28, lineHeight: 1.15, marginTop: 8}}>
                                {videoTitle(introVideo)}
                              </strong>
                              {videoDescription(introVideo) && (
                                <span style={{fontSize: 15, lineHeight: 1.4, marginTop: 8, maxWidth: 620, opacity: 0.86}}>
                                  {videoDescription(introVideo)}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="card-body d-flex flex-column">
                        {sharedVideo ?
                        <Button style={{alignSelf: 'flex-end'}}variant="primary" onClick={() => 
                          window.open(selectedPlayerUrl, '_blank')}>
                            Full screen
                          </Button>
                        :null}
                        <h5 className="card-title" style={{marginTop: 20, marginBottom: 20}}>{sharedVideo ? sharedVideo.name : ''}</h5>
                        <ul className="list-unstyled" style={{marginBottom: 20}}>
                          <li>
                            {isFolderSharing ?
                              'Guarda gli highlight selezionati e condivisi con te.' :
                              isPlaylistSharing ?
                                'Guarda la playlist condivisa in sequenza oppure scegli sotto uno degli highlight inclusi.' :
                                sharedVideo ? sharedVideo.description : ''}
                          </li>
                        </ul>
                        {isFolderSharing ? (
                          <Fragment>
                            <div className="shared-folder-heading">
                              <h6 className="lightblue_text">{t('CHOOSE_HIGHLIGHT')}</h6>
                              <span>{t('VIDEO_COUNT', {count: folderVideos.length})}</span>
                            </div>
                            {folderVideos.length === 0 ? (
                              <p>{t('NO_HIGHLIGHTS_IN_FOLDER')}</p>
                            ) : null}
                            <div className="shared-folder-video-grid">
                              {folderVideos.map((video, index) => (
                                <button
                                  key={video.videoId}
                                  type="button"
                                  className={`shared-folder-video-card ${selectedFolderVideo && selectedFolderVideo.videoId === video.videoId ? 'active' : ''}`}
                                  onClick={() => selectFolderVideo(video)}
                                >
                                  <span className="shared-folder-video-number">{index + 1}</span>
                                  <span className="shared-folder-video-content">
                                    <strong>{videoTitle(video)}</strong>
                                    <small>{videoDescription(video)}</small>
                                  </span>
                                  <span className="shared-folder-video-action">
                                    {selectedFolderVideo && selectedFolderVideo.videoId === video.videoId ? 'In riproduzione' : 'Guarda'}
                                  </span>
                                </button>
                              ))}
                            </div>
                          </Fragment>
                        ) : null}
                        {isPlaylistSharing && playlistVideos.length > 0 ? (
                          <Fragment>
                            <div className="shared-folder-heading">
                              <h6 className="lightblue_text">Highlight della playlist</h6>
                              <span>{playlistVideos.length} highlight</span>
                            </div>
                            <div className="shared-folder-video-grid">
                              {playlistVideos.map((video, index) => {
                                const isSelected = selectedPlaylistVideoIndex === index;
                                return (
                                  <button
                                    key={`${video.videoId || video.id || video.name || 'playlist-video'}-${index}`}
                                    type="button"
                                    className={`shared-folder-video-card ${isSelected ? 'active' : ''}`}
                                    onClick={() => selectPlaylistVideo(video, index)}
                                  >
                                    <span className="shared-folder-video-number">{index + 1}</span>
                                    <span className="shared-folder-video-content">
                                      <strong>{videoTitle(video)}</strong>
                                      <small>{videoDescription(video)}</small>
                                    </span>
                                    <span className="shared-folder-video-action">
                                      {isSelected ? 'In riproduzione' : 'Guarda da qui'}
                                    </span>
                                  </button>
                                );
                              })}
                            </div>
                          </Fragment>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      <Modal show={isLoginModalVisible} onHide={hideLoginModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('VIDEO_SHARED')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p><Trans i18nKey='RESERVED_VIDEO_1' /></p>
          </div>
          <div>
            <p>{t('RESERVED_VIDEO_2')}</p>
          </div>
          <div>
            <p>{t('RESERVED_VIDEO_3')}</p>
          </div>
          <div className="d-flex flex-row-reverse">
          <Button variant="primary"  onClick={v => window.open(`/sign-up-player`, '_blank')}>{t('SIGN_IN_BUTTON')}</Button>
          <Button variant="secondary" style={{marginRight: 10}} onClick={v => window.open(`/login`, '_blank')}>{t('LOGIN_BUTTON')}</Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={hideLoginModal}>
            {t('CLOSE_BUTTON')}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

VideoSharing.propTypes = {
  match: PropTypes.object.isRequired,
  getSharedVideo: PropTypes.func.isRequired,
  sharedVideo: PropTypes.object,
  token: PropTypes.object
};

VideoSharing.defaultProps = {
  sharedVideo: null,
  token: null
};

export default (connect(
  ({player: {sharedVideo, isLoginModalVisible}, login: {token}}) => ({
    sharedVideo,
    token,
    isLoginModalVisible
  }),
  dispatch => ({
    getSharedVideo: sharedId => {
      dispatch(getSharedVideo(sharedId));
    },
    hideLoginModal: () => {
      dispatch(hideLoginModal());
    },
    goto: (path, action = null) => e => {
      e.preventDefault();
      if (action) {
        dispatch(action());
      }
  
      dispatch(push(path));
    },
  })
)(VideoSharing));
